import { useState } from "react";
import { Printer, Link2 } from "lucide-react";
import { toast } from "sonner";
import { Poster, bookingLink } from "@/components/Poster";
import { inputCls } from "@/components/AuthLayout";
import { PosterStats } from "@/components/fleet/PosterStats";

const SUGGESTED = ["Vision City Taxi Stand", "Jacksons Airport", "Boroko Foodworld", "Waigani Taxi Stand", "Gordons Market"];

export const PostersPanel = () => {
  const [place, setPlace] = useState("");
  const open = () => window.open(`/poster${place.trim() ? `?place=${encodeURIComponent(place.trim())}` : ""}`, "_blank");
  const copy = () => navigator.clipboard.writeText(bookingLink(place.trim())).then(() => toast.success("Booking link copied"));
  return (
    <div className="space-y-8">
    <PosterStats />
    <div className="grid gap-8 lg:grid-cols-[minmax(0,1fr)_minmax(0,1fr)]">
      <div className="space-y-5 rounded-2xl border border-blue-100 bg-white p-6">
        <div>
          <p className="font-semibold text-slate-900">Where will this poster go?</p>
          <p className="text-sm text-slate-500">Optional. Shown under the QR code, e.g. a taxi stand or shop name.</p>
        </div>
        <input data-testid="poster-place-input" className={inputCls} maxLength={40} placeholder="e.g. Vision City Taxi Stand" value={place} onChange={(e) => setPlace(e.target.value)} />
        <div className="flex flex-wrap gap-2">
          {SUGGESTED.map((s) => (
            <button key={s} data-testid={`poster-suggest-${s.split(" ")[0].toLowerCase()}`} onClick={() => setPlace(s)} className="rounded-full border border-blue-100 bg-[#F4F8FD] px-3 py-1.5 text-xs font-semibold text-blue-800 hover:border-blue-300">{s}</button>
          ))}
        </div>
        <div className="flex flex-wrap gap-3 pt-2">
          <button data-testid="poster-print-button" onClick={open} className="inline-flex items-center gap-2 rounded-full bg-blue-700 px-5 py-2.5 text-sm font-semibold text-white shadow-lg shadow-blue-700/25 hover:bg-blue-600"><Printer className="h-4 w-4" /> Open printable poster</button>
          <button data-testid="poster-copy-link-button" onClick={copy} className="inline-flex items-center gap-2 rounded-full border border-blue-200 px-5 py-2.5 text-sm font-semibold text-blue-800 hover:bg-blue-50"><Link2 className="h-4 w-4" /> Copy booking link</button>
        </div>
        <p className="text-xs text-slate-500">Prints on A4. Scanning opens the Comfort Taxi booking screen — passengers sign in or create an account, then book.</p>
      </div>
      <div className="mx-auto w-full max-w-sm overflow-hidden rounded-2xl shadow-2xl" data-testid="poster-preview"><Poster place={place.trim()} /></div>
    </div>
    </div>
  );
};
